module.exports = __webpack_public_path__ + "h5/img/support.37442214.png";